import ApiService from "./base";
import { config } from "@/utils/config";
export default class MarketplaceService extends ApiService {
    constructor(){
        super({
            baseURL: `${config.apiUrl}/marketplace`,
            withCredentials: false
        });
    }
    async redirect(resolveCustomerMock) {
        return this.post({
            url: '/redirect',
            data: {
                'x-amzn-marketplace-token': 'test-marketplace-token',
                'x-resolve-customer-mock': resolveCustomerMock,
                'x-validate-entitlement-mock': true
            }
        });
    }
}
